import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import '@fil-global/gds-webcomponents/fil-icon/fil-icon.component'
import { Button } from 'gdpp-components/dist/cjs/components/atoms'

import './style.scss'

const PageLevelMessage = ({ id, inversed, status, title, content, closable, linkLabel, linkUrl, hasIcon, show }) => {
  const [showMessage, setMessageStatus] = useState()

  const iconTemplate = () => {
    let icon = 'custom-info-circle'
    let label = 'Information'
    let color = 'blue-500'

    if (status) {
      switch (status) {
        case 'error':
          icon = 'custom-alert-circle'
          label = 'error'
          color = 'brand-error-red'
          break
        case 'info':
          icon = 'custom-info-circle'
          label = 'Information'
          color = 'blue-500'
          break
        case 'success':
          icon = 'custom-check-circle-1'
          label = 'Success'
          color = 'green-600'
          break
        case 'warning':
          icon = 'custom-alert-diamond'
          label = 'Warning'
          color = 'orange-400'
          break
        default:
          console.warn('There is no status')
      }
      return <fil-icon icon={icon} color={color} filled label={label} />
    }

    return ''
  }

  const closeMessage = () => {
    setMessageStatus(false)
  }

  useEffect(() => {
    setMessageStatus(show)
  }, [])

  return (
    <React.Fragment>
      {showMessage && (
        <div
          {...(id ? { id } : {})}
          className={classnames('fil-page-level-message', {
            'fil-page-level-message--inversed': inversed,
            [`fil-page-level-message--${status}`]: status
          })}
          role="alert"
        >
          {hasIcon && <div className="fil-page-level-message__icon">{iconTemplate()}</div>}
          <div
            id={`${id}__msg-body`}
            className={classnames('fil-page-level-message__body', {
              'fil-page-level-message__body--no-icon': !hasIcon
            })}
          >
            {closable && (
              <Button
                kind="icon"
                aria-label="Close"
                extraClasses="fil-page-level-message__close"
                onClick={() => {
                  closeMessage()
                }}
                icon="close"
                size="16"
              />
            )}
            {title && (
              <p className="fil-page-level-message__title">
                <strong>{title}</strong>
              </p>
            )}
            {content && (
              <div
                className="fil-page-level-message__text"
                dangerouslySetInnerHTML={{
                  __html: content
                }}
              />
            )}
            {linkUrl && linkLabel && (
              <p className="fil-page-level-message__link">
                <a href={linkUrl} aria-label={linkLabel}>
                  {linkLabel}
                </a>
              </p>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

PageLevelMessage.propTypes = {
  id: PropTypes.string,
  inversed: PropTypes.bool,
  status: PropTypes.oneOf(['success', 'info', 'warning', 'error']),
  title: PropTypes.string,
  closable: PropTypes.bool,
  linkLabel: PropTypes.string,
  linkUrl: PropTypes.string,
  hasIcon: PropTypes.bool,
  show: PropTypes.bool,
  content: PropTypes.string
}

PageLevelMessage.defaultProps = {
  id: '',
  inversed: false,
  status: 'info',
  title: '',
  closable: false,
  linkLabel: '',
  linkUrl: '',
  hasIcon: true,
  show: true,
  content: ''
}

export default PageLevelMessage
